var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInboxArrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Upload"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 24,
    width: 24,
    id: "Boundary"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m14,14l-4,0l0,-3l-2,0l4,-4l4,4l-2,0l0,3m2,-3m-11,4l0,-10l14,0l0,10l-4,0a3,3 0 0 1 -6,0l-4,0m14,-12l-14,0a2,2 0 0 0 -2,2l0,14a2,2 0 0 0 2,2l14,0a2,2 0 0 0 2,-2l0,-14a2,2 0 0 0 -2,-2",
    id: "color"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxArrowUp);
export default __webpack_public_path__ + "static/media/Inbox-Arrow-Up.0f707a919b6749b537a01281a20456c4.svg";
export { ForwardRef as ReactComponent };